<template>
  <div class="control example">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          Examples
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <el-select
          v-model="exampleValue"
          class="control__select"
          placeholder="Default"
          :disabled="viewSMVMode"
          @change="changeExample"
        >
          <el-option
            v-for="(value, index) in examples"
            :key="index"
            :label="value.label"
            :value="value.value"
          />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import examples from '@/assets/examples.json'
import { mapState } from 'vuex'
export default {
  name: 'ExamplesControl',
  data() {
    return {
      exampleValue: 'default',
      examples: examples
    }
  },
  computed: {
    ...mapState([
      'example',
      'viewSMVMode'
    ])
  },
  watch: {
    example(value) {
      this.exampleValue = value
    }
  },
  methods: {
    async changeExample () {
      await this.$store.dispatch('changeClearOptions', false)
      await this.$store.dispatch('changeClearOptionsCSS', false)
      await this.$store.dispatch('changeClearOptionsJS', false)
      setTimeout(() => {
        this.$store.dispatch('changeExample', {type: this.exampleValue})
      }, 200)
    }
  }
}
</script>

